import React, { useEffect } from "react";
import { IProduct } from "../../../types/product.type";
import DefaultModal from "../DefaultModal/DefaultModal";
import AddDiscountForm from "../forms/AddDiscountForm/AddDiscountForm";
import ModalTitle from "../ModalTitle/ModalTitle";
import styles from "./styles.module.scss";

interface Props {
  onClose: () => void;
  onApply: () => void;
  products: IProduct[];
}

const AddDiscountModal: React.FC<Props> = (props) => {
  const onApply = () => {
    props.onApply();
    props.onClose();
  };

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        props.onClose();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.onClose]);

  return (
    <DefaultModal>
      <div className={styles.container}>
        <ModalTitle
          onClose={props.onClose}
          title="Додати дісконт для товарів"
          subTitle='Додайте новий дісконт товарів до системи. Заповніть необхідну інформацію та натисніть "Додати".'
        ></ModalTitle>
        <AddDiscountForm
          onApply={onApply}
          onClose={props.onClose}
          products={props.products}
        />
      </div>
    </DefaultModal>
  );
};

export default AddDiscountModal;
